import { Menu, Sun, Moon, Globe } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useUIStore } from '@/stores/uiStore'
import { useAuth, useSaveTheme } from '@/api/hooks/useAuth'
import { useLanguage } from '@/i18n/LanguageContext'
import { isStagingMode } from '@/lib/staging'
import { MetaStatusBadge } from '@/components/layout/MetaStatusBadge'

interface TopbarProps {
  title?: string
}

export function Topbar({ title }: TopbarProps) {
  const toggleSidebar = useUIStore((s) => s.toggleSidebar)
  const { theme, setTheme } = useTheme()
  const saveTheme = useSaveTheme()
  const { data: user } = useAuth()
  const { language, setLanguage, t } = useLanguage()

  const handleToggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    saveTheme.mutate(next)
  }

  const handleToggleLanguage = () => {
    setLanguage(language === 'pt' ? 'en' : 'pt')
  }

  return (
    <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-border bg-background px-4 md:px-8">
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-secondary text-foreground transition-colors hover:bg-muted md:hidden"
        >
          <Menu className="h-4 w-4" />
        </button>
        {title && <h1 className="text-base font-semibold tracking-tight">{title}</h1>}
      </div>

      <div className="flex items-center gap-2">
        <MetaStatusBadge />
        {user?.username !== 'vini' && !isStagingMode() && (
          <button
            onClick={handleToggleLanguage}
            className="flex h-8 items-center gap-1.5 rounded-lg border border-border px-2.5 text-xs font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
            title={language === 'pt' ? 'Switch to English' : 'Mudar para Portugues'}
          >
            <Globe className="h-3.5 w-3.5" />
            {language === 'pt' ? 'EN' : 'PT'}
          </button>
        )}
        <button
          onClick={handleToggleTheme}
          className="flex h-8 w-8 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
          title={theme === 'dark' ? t('Modo claro') : t('Modo escuro')}
        >
          {theme === 'dark' ? <Sun className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
        </button>
      </div>
    </header>
  )
}
